// extracted by mini-css-extract-plugin
module.exports =  {"price":"_32bbee5fda--price--sZwIA","value":"_32bbee5fda--value--idHVm","currency":"_32bbee5fda--currency--qMhoF"};